import { useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from '~/components/ui/Button';
import { deleteOrganization } from '~/lib/.client/api/organizations';
import { WINDOW_RELOAD_TIMEOUT } from '~/lib/constants';
import { teamStore } from '~/lib/stores/team';
import type { OrganizationData } from '~/types/organization';
import { withSpinner } from '~/utils/withSpinner';

export const FreeTeamAdminScreen = ({ organization }: { organization: OrganizationData }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteOrg = () => {
    withSpinner({
      action: async () => {
        try {
          await deleteOrganization({ org: organization });
          toast.success('Your team has been discarded.');

          setTimeout(() => {
            window.location.reload();
          }, WINDOW_RELOAD_TIMEOUT);
        } catch (error) {
          toast.error(error instanceof Error ? error.message : 'An unknown error occurred');
        }
      },
      onStateUpdate: setIsDeleting,
    });
  };

  return (
    <div className="flex flex-col gap-4 items-center h-full justify-center">
      <div className="i-ph:users-three text-bolt-ds-text-secondary w-6 h-6" />
      <div className="text-bolt-ds-text-primary text-lg font-semibold text-center max-w-80">
        Resume {organization.name} Team Setup?
      </div>
      <div className="text-bolt-ds-text-secondary text-base text-center max-w-80">
        You started creating a team but haven’t finished yet. Choose a plan now or discard it and start fresh later.
      </div>
      <div className="flex gap-4 justify-center">
        <Button variant="secondary" onClick={handleDeleteOrg} loading={isDeleting} disabled={isDeleting}>
          Discard Team
        </Button>
        <Button
          onClick={() => {
            teamStore.createTeamData.set({
              organization,
              level: organization.setupState?.level ?? 'teams_1',
              interval: organization.setupState?.interval ?? 'monthly',
              members: [],
            });
          }}
        >
          Resume Team Setup
        </Button>
      </div>
    </div>
  );
};
